import { render, staticRenderFns } from "./SearchBar.vue?vue&type=template&id=5f873fdf&scoped=true&"
import script from "./SearchBar.vue?vue&type=script&lang=js&"
export * from "./SearchBar.vue?vue&type=script&lang=js&"
import style0 from "./SearchBar.vue?vue&type=style&index=0&id=5f873fdf&lang=scss&scoped=true&"
import style1 from "./SearchBar.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f873fdf",
  null
  
)

export default component.exports